<template lang="pug">
.display-contents
  slot(v-if="exclude ? !isAllowed : isAllowed")
</template>

<script>
export default {
  props: {
    roles: { type: Array, default: () => ([]) },
    exclude: { type: Boolean, default: false },
  },
  computed: {
    rolesValues() {
      return this.roles.map((i) => i.value);
    },
    isAllowed() {
      return this.$user.data && this.rolesValues.includes(this.$user.data.role);
    },
  },
};
</script>
